import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Response } from '@shared/store';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Observable } from 'rxjs';
import { AvatarComponent } from 'thkee-common';

@Component({
  selector: 'app-assignments-accordion',
  templateUrl: './assignments-accordion.component.html',
  styleUrls: ['./assignments-accordion.component.scss'],
  standalone: true,
  imports: [NgFor, NgIf, RouterLink, AngularSvgIconModule, AsyncPipe, NgClass, AvatarComponent],
})
export class AssignmentsAccordionComponent implements OnInit {
  @Input() assignments: Observable<Response> | undefined;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  isCollapse: boolean[] = [];
  collapse(i: any) {
    this.isCollapse[i] = !this.isCollapse[i];
  }
  seeSubmission(event: any, data: any) {
    event.stopPropagation();
    this.router.navigate(['/instructor/assignments/courses-assignment/' + data.course_id]);
  }
}
